/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
import type * as Types from './graphql.schema-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export * from './graphql.schema-types';
export type CreateZalamoPayAccountMutationVariables = Exact<{
  input: Types.ZalamoPayP24RegisterInput;
  organizationId: string;
}>;

export type CreateZalamoPayAccountMutation = {
  createZalamoPayAccount: {
    status: boolean | null;
    link: string | null;
  } | null;
};

export const CreateZalamoPayAccountDocument = gql`
  mutation createZalamoPayAccount(
    $input: ZalamoPayP24RegisterInput!
    $organizationId: ID!
  ) {
    createZalamoPayAccount(input: $input, organizationId: $organizationId) {
      status
      link
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class CreateZalamoPayAccountGQL extends Apollo.Mutation<
  CreateZalamoPayAccountMutation,
  CreateZalamoPayAccountMutationVariables
> {
  document = CreateZalamoPayAccountDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
